<template>
  <InfoContent>
    <div class="info-lead">
      <p>
        Enregistrer la relance <strong>termine l'appel</strong> et vous donne
        rendez-vous avec le client à la date choisie. Le jour venu, c'est à vous de
        l'appeler : rien ne part tout seul.
      </p>
      <p>
        La date se choisit <strong>au plus tard 29 jours</strong> après l'envoi du
        devis, ou à partir d'aujourd'hui s'il n'est pas encore parti : la date limite
        s'affiche sous le champ.
      </p>
    </div>

    <div class="info-section">
      <h3><i class="fas fa-bolt"></i> Tout de suite</h3>
      <div class="info-item">
        <div class="info-item-content">
          <p>
            <strong>Une tâche « Relance téléphonique »</strong> est créée à votre
            nom, pour la date et l'heure choisies. Vous la retrouvez ce jour-là
            dans « Mes tâches du jour ».
          </p>
          <p>
            Si <strong>« Prévenir le client par email »</strong> est coché, le
            client reçoit tout de suite un e-mail qui lui annonce votre rappel à
            cette date.
          </p>
          <p>
            La priorité choisie (froid, tiède, chaud, très chaud) est reportée sur
            la demande, et l'appel s'ajoute à son historique comme décroché.
          </p>
        </div>
      </div>
    </div>

    <div class="info-section">
      <h3><i class="fas fa-calendar-check"></i> D'ici là</h3>
      <div class="info-item">
        <div class="info-item-content">
          <p>
            Si le devis est signé ou la demande perdue avant la date, la tâche
            disparaît d'elle-même.
          </p>
        </div>
      </div>
      <div class="info-item">
        <div class="info-item-header">
          <strong>Si le devis est déjà envoyé</strong>
        </div>
        <div class="info-item-content">
          <p>
            Ses relances par e-mail continuent : le client en reçoit une 7 jours,
            puis 21 jours après l'envoi.
          </p>
          <p>
            Sans signature <strong>30 jours après l'envoi</strong>, la demande passe
            en « Devis perdu » et votre relance disparaîtrait avec elle : c'est la
            raison de la date limite.
          </p>
        </div>
      </div>
    </div>
  </InfoContent>
</template>

<script setup>
import InfoContent from './InfoContent.vue'
</script>
